import { useState } from 'react'

import { useAsyncCallback } from '../../../../hooks'
import { EpostCell } from '../../../Epost'
import { DocFlowSendingWidgetNotificationType } from '../../DocFlowSending'
import { useDocFlowContext } from '../useDocFlowContext'
import { useDocFlowSendingContext } from '../useDocFlowSendingContext'

export function useDocFlowEpostSettingsWidget({ index }) {
  const { phaseDisabled } = useDocFlowContext()

  const {
    calculatingData,
    epostFormikRef,
    epostNotificationsData,
    epostSettings,
    handleClickNextWidget,
    handleClickPreviousWidget,
    noEpostSettings,
  } = useDocFlowSendingContext()

  const [isError, setError] = useState(false)

  const {
    handlePrependNotification,
    handleRemoveAdditionalNotifications,
    handleRemoveNotification,
    notifications,
    widgetNotifications,
  } = epostNotificationsData

  const handleClickNext = useAsyncCallback(() => {
    if (epostFormikRef.current?.dirty) {
      handleRemoveAdditionalNotifications()

      handlePrependNotification(widgetNotifications.costIsOutdated)

      return new Promise(resolve => resolve(null))
    }

    if (phaseDisabled) {
      return handleClickNextWidget(index)
    }

    if (!epostSettings[EpostCell.SendToCalculateAt] && !noEpostSettings) {
      handleRemoveAdditionalNotifications()

      handlePrependNotification(widgetNotifications.noCalculation)

      return
    }

    if (
      (epostSettings[EpostCell.ValidationErrors].length > 0 ||
        !calculatingData?.isEnoughCredits) &&
      !noEpostSettings
    ) {
      return new Promise(resolve => resolve(null))
    }

    return handleClickNextWidget()
      .then(() => {
        handleRemoveAdditionalNotifications()

        setError(false)
      })
      .catch(() => {
        handlePrependNotification(
          widgetNotifications[DocFlowSendingWidgetNotificationType.Error]
        )

        handleRemoveNotification(
          widgetNotifications[DocFlowSendingWidgetNotificationType.Success].id
        )

        setError(true)
      })
  }, [
    calculatingData?.isEnoughCredits,
    epostSettings,
    handleClickNextWidget,
    handlePrependNotification,
    handleRemoveAdditionalNotifications,
    handleRemoveNotification,
    index,
    noEpostSettings,
    phaseDisabled,
    widgetNotifications,
  ])

  function handleClickPrevious() {
    if (phaseDisabled) {
      return handleClickPreviousWidget(index)
    }

    handleClickPreviousWidget().then(() => {
      handleRemoveNotification(widgetNotifications.error.id)
    })
  }

  return {
    handleClickNext,
    handleClickPrevious,
    isError,
    notifications,
  }
}
